import Menu from 'antd/lib/menu'
import './index.less'

export default Menu



// WEBPACK FOOTER //
// ./src/elements/menu/index.js